import { Typography } from '@archer-technologies/ui-components';
import { Getter, Plugin, Template, TemplateConnector } from '@devexpress/dx-react-core';
import { Table, TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';
import TableCell from '@mui/material/TableCell';
import * as React from 'react';
import { GridProps } from '../Grid.types';

export interface ImagePluginProps {
  translate: any;
  imageValue: GridProps['imageValue'];
  imagePath: GridProps['imagePath'];
}

const pluginDependencies = [{ name: 'Table' }];

const ImagePlugin = ({ translate, imageValue, imagePath }: ImagePluginProps) => {
  let image: any;

  if (imageValue) {
    const src: string = imagePath + imageValue;
    let imageName: string = src;
    const slashIndex: number = src.lastIndexOf('/');
    if (slashIndex > -1) {
      imageName = src.substring(slashIndex + 1);
    }

    const imageProps = {
      src,
      height: 17
    };

    image = <img alt={imageName} width="100%" {...imageProps} />;
  }

  return (
    <Plugin name="ImageColumn" dependencies={pluginDependencies}>
      <Getter
        name="tableColumns"
        computed={({ tableColumns }) => {
          return [...tableColumns, { type: 'image', key: Symbol('Image').toString() }];
        }}
      />
      <Template
        name="tableCell"
        predicate={({ tableColumn, tableRow }: any) => tableColumn.type === 'image' && tableRow.type === TableHeaderRow.ROW_TYPE}
      >
        <TemplateConnector>
          {() => (
            <TableCell>
              <Typography variant="h6" color="textPrimary">
                {translate('cmmn:image')}
              </Typography>
            </TableCell>
          )}
        </TemplateConnector>
      </Template>
      <Template name="tableCell" predicate={({ tableColumn, tableRow }: any) => tableColumn.type === 'image' && tableRow.type === Table.ROW_TYPE}>
        <TemplateConnector>
          {() => {
            return <TableCell>{image}</TableCell>;
          }}
        </TemplateConnector>
      </Template>
    </Plugin>
  );
};

export { ImagePlugin };
